import React, { useState } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import boat from "../../../../../assets/images/OUR SERVICES/12.Boat accessories.png";
import EnquiryModal from '../../../../../common/pages/enquiryModal';
const Boat = () => {
    const [modal, setModal] = useState(false);
    const toggleModal = () => setModal(!modal);
    return (
        <React.Fragment>

            <section className="section bg-light py-5" id="features">
                <Container>
                    <Row className="align-items-center gy-4">
                        <div className="text-muted">
                            <div className="text-center ">
                                <h2 className="fw-bold mt-5" style={{ fontSize: "2rem", color: "#F15A29" }}>Boat Accessories</h2>

                            </div>
                        </div>
                    </Row>
                </Container>
            </section>

            <section className="section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={10} sm={10}>
                            <Row className="align-items-center gy-4">
                                <Col lg={6} md={12}>
                                    <img
                                        src={boat}
                                        alt="Premium Corporate Gifts"
                                        className="img-fluid rounded"
                                        style={{ width: "100%", height: "auto" }}
                                    />
                                </Col>
                                <Col lg={6} md={12}>

                                    <div className="text-black">
                                        <p><strong>Boat Earphones & Headphones</strong> – Experience high-quality audio with noise cancellation, deep bass, and long battery life.</p>
                                        <p><strong>Boat Smartwatches</strong> – Stylish and feature-packed smartwatches with fitness tracking, heart rate monitoring, and seamless connectivity.</p>
                                        <p><strong>Boat Bluetooth Speakers</strong> – Portable and powerful speakers with immersive sound quality, water resistance, and long-lasting battery backup.</p>
                                        <p><strong>Boat Wireless Earbuds</strong> – Compact and comfortable earbuds with touch controls, superior sound, and sweat-resistant designs.</p>
                                        <p><strong>Boat Soundbars</strong> – High-performance soundbars for an immersive home theater experience with deep bass and surround sound.</p>
                                        <p><strong>Boat Power Banks</strong> – Reliable and fast-charging power banks to keep your devices powered up on the go.</p>
                                        <p><strong>Boat Gaming Accessories</strong> – High-quality gaming headphones, mouse pads, and other accessories for an enhanced gaming experience.</p>
                                        <p><strong>Boat Charging Cables & Adapters</strong> – Durable and fast-charging cables and adapters for all your electronic devices.</p>

                                    </div>
                                </Col>

                            </Row>
                        </Col>
                    </Row>

                </Container>
                <EnquiryModal isOpen={modal} toggle={toggleModal} />
            </section>
            <section className="section  py-5" style={{ backgroundColor: " rgb(52, 81, 159)" }} id="features">
                <Container>
                    <Row className="justify-content-center">
                        <div className='text-center '>
                            <Button className='px-4 py-2 fw-bold' onClick={toggleModal}
                                style={{ background: "rgb(238, 99, 82)", borderRadius: "20px", color: "white", fontSize: "20px" }}
                            >
                                Enquiry Now
                            </Button>
                        </div>
                    </Row>
                </Container>
            </section>
        </React.Fragment >
    );
};

export default Boat;